import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AppTableComponent, AssessmentAreaBasicModel,
  Form, FormElement, MessagesComponent, RequestsService, TranslationManager, ViewState
} from 'src/common';
import { UsersActiveEmployeesSelectComponent } from 'src/views';
import { Location } from '@angular/common';
import { OpnBoardMembersListService, OpnBoardMembersSaveModel } from 'src/common/services/requests/opn-steps/opn-boardmembers-list';
import { ComponentName } from 'src/common/enums/componentsName';

@Component({
  selector: 'opn-boardmember-list',
  templateUrl: 'opn-boardmember-list.component.html'
})

export class OpnBoardMemberListComponent implements OnInit {

  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @ViewChild("usersActiveEmployeesSelectComponent") usersActiveEmployeesSelectComponent: UsersActiveEmployeesSelectComponent;

  @Input() state: ViewState;

  requestId: number;
  form: Form = new Form();
  viewState = ViewState;
  assessmentAreas: AssessmentAreaBasicModel[];

  show: boolean = false;
  resolve: any;
  isReadonly: boolean = false;

  translationManager = TranslationManager;

  constructor(
    private requestsService: RequestsService,
    private opnBoardMembersListService: OpnBoardMembersListService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location) {
  }

  ngOnInit(): void {
    this.initForm();
    this.requestsService.getRequestAssessmentAreas(this.requestId).then((items: AssessmentAreaBasicModel[]) => {
      this.assessmentAreas = items;
    });
  }

  private initForm(): void {
    this.form.elements["employeeId"] = new FormElement();
    this.form.elements["employeeId"].state.mandatory = true;

    this.form.elements["employeeFullName"] = new FormElement();
    this.form.elements["organizationalUnit"] = new FormElement();
    this.form.elements["employeePosition"] = new FormElement();
    this.form.elements["personnelArea"] = new FormElement();
  }

  selectActiveEmployee() {
    this.usersActiveEmployeesSelectComponent.showModal(this.requestId,ComponentName.OpnBoardMembersList + '').then((id: number) => {
      if (id)
      {
        this.form.elements['employeeId'].value = id;
        let selectedEmployee = this.usersActiveEmployeesSelectComponent.getEmployeeById(id);
        this.form.elements["employeeFullName"].value = selectedEmployee.userFullName;
        this.form.elements["organizationalUnit"].value = selectedEmployee.organizationalUnit;
        this.form.elements["employeePosition"].value = selectedEmployee.employeePosition;
        this.form.elements["personnelArea"].value = selectedEmployee.personnelArea;
      }
    });
  }

  showModal(): Promise<boolean> {
    this.show = true;

    return new Promise((resolve) => {
      this.resolve = resolve;
    });
  }

  createModal(requestId): Promise<boolean> {
    this.isReadonly = false;
    this.requestId=requestId;
    this.form.elements['employeeId'].value = null;
    this.form.elements['employeeId'].value = undefined;
    this.form.elements['employeeFullName'].value = undefined;
    this.form.elements['organizationalUnit'].value = undefined;
    this.form.elements['employeePosition'].value = undefined;
    this.form.elements['personnelArea'].value = undefined;

    return this.showModal();
  }

  close() {
    this.show = false;
    if (this.resolve) {
      this.resolve(false);
    }
  }

  submit() {
    if (this.form.isValid()) {
      let model: OpnBoardMembersSaveModel = new OpnBoardMembersSaveModel();
      model.requestId = this.requestId;
      model.userId =this.form.elements['employeeId'].value;
      this.opnBoardMembersListService.save(model).then(() => {
        this.show = false;
        if (this.resolve) {
          this.resolve(true);
        }
      }).catch((reason: any) => {
        MessagesComponent.instance.showError([reason.error.messages]);
      });
    }
  }

  navigateToList() {
    this.location.back();
  }

}
